<template>
  <div class="dialog">
    <el-dialog title="评价项目" :close-on-click-modal="false" :visible.sync="evaluationItemShow" width="900px"
      :before-close="dialogClose" @open="dialogOpen">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="评价量" name="评价量">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :inline="true">
            <el-form-item label="评价主体" label-width="100px" prop="groupType">
              <el-select v-model="ruleForm.evaluateBody" placeholder="请选择" @change="evaluateBodySelect">
                <el-option v-for="item in evaluateBodyList" :key="item.dictValue" :label="item.dictLabel"
                  :value="item.dictValue">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div style="max-height: 350px; overflow-y: auto;">
            <div v-for="(project, projectIndex) in evaluationData" :key="project.id" class="project-container">
              <el-form ref="evaluationForm" :model="project" label-width="100px">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item :label="'评价项目' + (projectIndex + 1) + ':'" style="font-weight: bold;">
                      <el-input v-model="project.evaluationItem" placeholder="请输入" style="width: 300px;"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="顺序">
                      <el-input v-model="project.evaluationOrder" placeholder="请输入" style="width: 200px;"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-button type="danger" icon="el-icon-delete" circle @click="removeProject(project, projectIndex)"
                  class="delete-button"></el-button>
                <div v-for="(dimension, dimensionIndex) in project.dimensionArrays" :key="dimensionIndex"
                  class="dimension-container">
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="维度:">
                        <el-input v-model="dimension.evaluationDimension" placeholder="请输入"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="分值:">
                        <el-input v-model="dimension.evaluationScore" placeholder="请输入"
                          style="width: 200px;"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="内容:">
                    <el-input v-model="dimension.evaluationContent" placeholder="请输入" type="textarea"></el-input>
                  </el-form-item>
                  <el-button type="danger" icon="el-icon-delete" circle
                    @click="removeDimension(dimension, dimensionIndex, project.dimensionArrays)"
                    class="delete-button"></el-button>
                </div>
              </el-form>

              <div class="add-dimension-button">
                <el-button type="primary" @click="addDimension(projectIndex)">新增维度 <i
                    class="el-icon-plus"></i></el-button>
              </div>
            </div>
          </div>


          <div class="add-project-button">
            <el-button type="success" @click="addProject">新增项目 <i class="el-icon-plus"></i></el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="综合素质评价项目" name="综合素质评价项目">

          <div style="max-height: 400px; overflow-y: auto;">
            <div v-for="(project, projectIndex) in qualityEvaluationData" :key="projectIndex" class="project-container">
              <el-form ref="qualityEvaluationForm" :model="project" label-width="100px">
                <el-form-item :label="'项目' + (projectIndex + 1) + ':'" style="font-weight: bold;">
                  <el-input v-model="project.qualityItem" placeholder="请输入" style="width: 250px;"></el-input>
                  <el-button type="danger" icon="el-icon-delete" circle
                    @click="removeQualityProject(project, projectIndex, qualityEvaluationData)"
                    class="delete-button"></el-button>
                </el-form-item>

                <div v-for="(dimension, dimensionIndex) in project.childQualityItem" :key="dimensionIndex"
                  class="dimension-container">
                  <el-form-item :label="'子项目' + (dimensionIndex + 1) + ':'">
                    <el-input v-model="dimension.qualityItem" placeholder="请输入" style="width: 300px;"></el-input>
                  </el-form-item>
                  <el-form-item label="要求:">
                    <!-- 已有标签 -->
                    <!-- <el-tag :key="tag.id" v-for="(tag, tagIndex) in dimension.childQualityItem" closable
                      :disable-transitions="false" @close="handleClose(tagIndex, dimension.childQualityItem)">
                      {{ tag.qualityItem }}
                    </el-tag> -->
                    <el-tag :key="tag.id" v-for="(tag, tagIndex) in dimension.childQualityItem" closable
                      :disable-transitions="false" @close="handleClose(tagIndex, dimension.childQualityItem)"
                      @click="enableEdit(tag)" style="margin-right: 10px; cursor: pointer;">
                      <span v-if="!tag.isEditing">{{ tag.qualityItem }}</span>
                      <el-input v-else size="small" v-model="tag.qualityItem" @blur="saveEdit(tag)"
                        @keyup.enter.native="saveEdit(tag)" class="input-new-tag" autofocus ref="editInput" />
                    </el-tag>

                    <!-- 新增输入框 -->
                    <el-input class="input-new-tag" v-if="dimension.inputVisible" v-model="dimension.newTagInput"
                      ref="saveTagInput" size="small" @keyup.enter.native="addNewTag(dimension)"
                      @blur="addNewTag(dimension)" />

                    <!-- 添加按钮 -->
                    <el-button v-else class="button-new-tag" size="small" @click="showInput(dimension)">+
                      新要求
                    </el-button>
                  </el-form-item>
                  <el-button type="danger" icon="el-icon-delete" circle
                    @click="removeQualityProject(dimension, dimensionIndex, project.childQualityItem)"
                    class="delete-button"></el-button>
                </div>

                <div class="add-dimension-button">
                  <el-button type="primary" @click="addQualityDimension(projectIndex, project)">新增子项目 <i
                      class="el-icon-plus"></i></el-button>
                </div>
              </el-form>
            </div>
          </div>

          <div class="add-project-button">
            <el-button type="success" @click="addQualityProject">新增项目 <i class="el-icon-plus"></i></el-button>
          </div>

        </el-tab-pane>
        <el-tab-pane label="学生学习生活评定项" name="学生学习生活评定项">
          <el-tag :key="tagIndex" v-for="(tag, tagIndex) in dynamicLifeTags" closable :disable-transitions="false"
            style="margin-bottom: 8px; cursor: pointer;" @close="handleLifeClose(tag)" @click="enableLifeEdit(tag)">
            <span v-if="!tag.isEditing">{{ tag.evaluateItem }}</span>
            <el-input v-else class="input-new-tag" size="small" v-model="tag.evaluateItem" @blur="saveLifeEdit(tag)"
              @keyup.enter.native="saveLifeEdit(tag)" style="width: 100px;" ref="lifeEditInput" autofocus />
          </el-tag>
          <el-input class="input-new-tag" v-if="inputLifeVisible" v-model="inputLifeValue" ref="saveLifeTagInput"
            size="small" @keyup.enter.native="handleLifeInputConfirm" @blur="handleLifeInputConfirm">
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showLifeInput">+ 评定项</el-button>
        </el-tab-pane>
      </el-tabs>
      <div class="form-btn" v-show="activeName != '学生学习生活评定项'">
        <el-button type="primary" @click="confirm">确认修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: [
    'evaluationItemShow',
    'evaluateBodyList'
  ],
  data() {
    return {
      activeName: '评价量',
      checked: true,
      ruleForm: {
        evaluateBody: '1',
      },
      rules: {
        evaluateBody: [{ required: true, message: '请选择评价主体', trigger: 'change' }]
      },
      // 领导评价
      evaluationData: [
      ],
      // 综合素质评定
      qualityEvaluationData: [
      ],
      isAddingTag: false,
      newTagInput: '',
      dynamicLifeTags: [],
      studentLifeList: [],
      inputLifeVisible: false,
      inputLifeValue: '',
    };
  },
  mounted() {
    this.selectTutorEvaluationScaleList();
  },
  methods: {
    enableLifeEdit(tag) {
      this.$set(tag, 'isEditing', true);
      this.$nextTick(() => {
        if (this.$refs.lifeEditInput && this.$refs.lifeEditInput[0]) {
          this.$refs.lifeEditInput[0].focus();
        }
      });
    },
    saveLifeEdit(tag) {
      // this.$set(tag, 'isEditing', false);

      let data = {
        "id": tag.id,
        "schoolId": this.school.id,
        "schoolName": this.school.schoolName,
        "evaluateItem": tag.evaluateItem
      };

      this.put(this.$url.updateStudentLife, data).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.$set(tag, 'isEditing', false);
        } else {
          this.$message.error(res.msg);
        }
      })
    },

    handleLifeClose(tag) {
      // let id = this.studentLifeList.find(item => item.evaluateItem == tag.evaluateItem).id;
      this.delete(this.$url.deleteStudentLifeById + "?id=" + tag.id).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.dynamicLifeTags.splice(this.dynamicLifeTags.indexOf(tag), 1);
        } else {
          this.$message.error(res.msg);
        }
      })
    },

    showLifeInput() {
      this.inputLifeVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveLifeTagInput.$refs.input.focus();
      });
    },

    handleLifeInputConfirm() {
      let inputValue = this.inputLifeValue;
      if (inputValue) {
        this.dynamicLifeTags.push({ evaluateItem: inputValue, isEditing: false });
        let data = {
          "schoolId": this.school.id,
          "schoolName": this.school.schoolName,
          "evaluateItem": inputValue
        };
        this.post(this.$url.insertStudentLife, data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            // this.dynamicLifeTags = [];
            // this.selectStudentLifeList();
          } else {
            this.$message.error(res.msg);
          }
        })
      };
      this.inputLifeVisible = false;
      this.inputLifeValue = '';
    },
    evaluateBodySelect(e) {
      this.selectTutorEvaluationScaleList();
    },
    selectComprehensiveQualityItem() {
      this.get(this.$url.selectComprehensiveQualityItem + "?schoolId=" + this.school.id).then(res => {
        // console.log("查询综合素质评定项目列表==>", res);
        if (res.code == 200) {
          this.qualityEvaluationData = res.data.map(item => {
            return {
              ...item,
              schoolId: this.school.id,
              schoolName: this.school.schoolName,
              childQualityItem: !item.childQualityItem ? [] : item.childQualityItem.map(childItem => {
                return {
                  ...childItem,
                  schoolId: this.school.id,
                  schoolName: this.school.schoolName,
                  childQualityItem: !childItem.childQualityItem ? [] : childItem.childQualityItem.map(grandChildItem => {
                    return {
                      ...grandChildItem,
                      schoolId: this.school.id,
                      schoolName: this.school.schoolName,
                      inputVisible: false,
                      newTagInput: '',
                      isEditing: false, // 新增字段
                    }
                  })
                }
              })
            }
          });

          // console.log(this.qualityEvaluationData);

        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 显示输入框
    showInput(dimension) {
      // 使用 Vue.set 来确保新属性是响应式的
      this.$set(dimension, 'inputVisible', true);
      this.$set(dimension, 'newTagInput', '');
      // this.$nextTick(() => {
      //   if (this.$refs.saveTagInput) {
      //     this.$refs.saveTagInput.focus();
      //   }
      // });
    },

    enableEdit(tag) {
      this.$set(tag, 'isEditing', true);
      this.$nextTick(() => {
        if (this.$refs.editInput && this.$refs.editInput[0]) {
          this.$refs.editInput[0].focus();
        }
      });
    },
    saveEdit(tag) {
      this.$set(tag, 'isEditing', false);
      // 这里可以添加保存逻辑，比如调用接口更新数据
      // console.log('保存内容:', tag.qualityItem);
    },

    // 添加新 tag
    addNewTag(dimension) {
      const val = dimension.newTagInput.trim();

      if (!val) {
        dimension.inputVisible = false;
        return;
      }

      // 避免重复
      const exists = dimension.childQualityItem.some(t => t.qualityItem === val);
      if (exists) {
        this.$message.warning('该要求已存在');
        return;
      }

      dimension.childQualityItem.push({
        schoolId: this.school.id,
        schoolName: this.school.schoolName,
        qualityItem: val,
        isEditing: false, // 新增字段
        id: null, // 可选，表示未保存项
      });

      dimension.inputVisible = false;
      dimension.newTagInput = '';
    },

    // 删除 tag
    handleClose(tagIndex, tagList) {
      // console.log(tagList[tagIndex]);
      this.$confirm('确定删除此要求吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (tagList[tagIndex].id) {
          let url = this.$url.deleteComprehensiveQualityById + "?id=" + tagList[tagIndex].id;

          this.delete(url).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.selectComprehensiveQualityItem();
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          tagList.splice(tagIndex, 1);
        }
      }).catch(() => { })
    },
    // 领导评价-新增项目
    addProject() {
      this.evaluationData.push({
        schoolId: this.school.id,
        schoolName: this.school.schoolName,
        evaluationItem: '',
        evaluationOrder: '',
        dimensionArrays: [],
      });
    },
    // 领导评价项删除
    removeProject(row, index) {
      this.$confirm('确定删除此项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (row.dimensionArrays.length && row.dimensionArrays[0].id) {
          let url = this.$url.deleteTutorEvaluationScaleById + "?id=" + row.dimensionArrays[0].id;

          row.dimensionArrays.forEach((item, index) => {
            if (index !== 0) {
              url += "&id=" + item.id;
            }
          });

          this.delete(url).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.selectTutorEvaluationScaleList();
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          this.evaluationData.splice(index, 1);
          this.$message.success('操作成功');
        }
      }).catch(() => { })
    },
    // 领导评价-新增维度
    addDimension(projectIndex) {
      this.evaluationData[projectIndex].dimensionArrays.push({
        "id": null,
        "evaluationDimension": "",
        "evaluationContent": "",
        "evaluationScore": 0,
        "evaluationBody": this.ruleForm.evaluateBody,
      });
    },
    // 领导评价子项目删除
    removeDimension(dimension, dimensionIndex, dimensionArrays) {
      // console.log(dimension, dimensionIndex)
      this.$confirm('确定删除此子项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (dimension.id) {
          let url = this.$url.deleteTutorEvaluationScaleById + "?id=" + dimension.id;

          this.delete(url).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.selectTutorEvaluationScaleList();
            } else {
              this.$message.error(res.msg);
            }
          })
        }
        else {
          dimensionArrays.splice(dimensionIndex, 1);
        }
      }).catch(() => { })
    },
    addQualityProject() {
      this.qualityEvaluationData.push({
        schoolId: this.school.id,
        schoolName: this.school.schoolName,
        parentId: 0,
        qualityItem: "",
        childQualityItem: [],
      });
    },
    getAllIds(data) {
      let ids = [];

      function traverse(node) {
        if (node.id !== undefined) {
          ids.push(node.id);
        }

        if (node.childQualityItem && Array.isArray(node.childQualityItem)) {
          node.childQualityItem.forEach(child => traverse(child));
        }
      }

      traverse(data);
      return ids;
    },
    // 综合评定删除
    removeQualityProject(project, projectIndex, data) {
      this.$confirm('确定删除此项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (project.id) {
          const allIds = this.getAllIds(project);

          let url = this.$url.deleteComprehensiveQualityByIds;
          allIds.forEach((id, index) => {
            url += index === 0 ? `?id=${id}` : `&id=${id}`;
          });

          this.delete(url).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.selectComprehensiveQualityItem();
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          data.splice(projectIndex, 1);
        }
      }).catch(() => { })
    },
    addQualityDimension(projectIndex, project) {
      this.qualityEvaluationData[projectIndex].childQualityItem.push({
        childQualityItem: [],
        schoolId: this.school.id,
        schoolName: this.school.schoolName,
        parentId: project.id,
        qualityItem: "",
      });
    },
    handleClick(tab, event) {
      // console.log(tab, event);
      this.dynamicLifeTags = [];
      if (this.activeName == '评价量') {
        this.selectTutorEvaluationScaleList();
      }
      else if (this.activeName == '综合素质评价项目') {
        this.selectComprehensiveQualityItem();
      } else if (this.activeName == '学生学习生活评定项') {
        this.selectStudentLifeList();
      }
    },
    // 学生学习生活评定
    selectStudentLifeList() {
      this.get(this.$url.selectStudentLifeList + "?schoolId=" + this.school.id).then(res => {
        // console.log(res);
        if (res.code == 200) {
          this.studentLifeList = res.rows;
          res.rows.forEach(item => {
            this.dynamicLifeTags.push({ id: item.id, evaluateItem: item.evaluateItem, isEditing: false });
          });
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    selectTutorEvaluationScaleList() {
      this.get(this.$url.selectTutorEvaluationScaleList + "?schoolId=" + this.school.id + "&evaluationBody=" + this.ruleForm.evaluateBody).then(res => {
        // console.log("查询领导评价列表==>", res);
        if (res.code == 200) {
          this.evaluationData = res.data;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 开启弹窗
    dialogOpen() {
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:evaluationItemShow", false);
    },
    // 领导评价-修改
    editTutorEvaluationScale() {
      this.put(this.$url.editTutorEvaluationScale, this.evaluationData).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.selectTutorEvaluationScaleList();
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    insertComprehensiveQuality() {
      // console.log(this.qualityEvaluationData);
      this.post(this.$url.insertComprehensiveQuality, this.qualityEvaluationData).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.selectComprehensiveQualityItem();
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    confirm() {
      if (this.activeName == '评价量') {
        this.editTutorEvaluationScale();
      }
      else if (this.activeName == '综合素质评价项目') {
        this.insertComprehensiveQuality();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./evaluationItemDialog.scss";
</style>

<style scoped>
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 14px !important;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}
</style>